// packages/app/src/components/Root/usePostHog.ts
import { useEffect } from 'react';
import posthog from 'posthog-js';
import { useUserProfile } from '@backstage/plugin-user-settings';
import { useApi, configApiRef } from '@backstage/core-plugin-api';


export function usePostHog() {
  const { profile } = useUserProfile();
  const config = useApi(configApiRef);

  useEffect(() => {
    // Read from Backstage config
    const clientKey = config.getOptionalString(
      'app.analytics.posthog.clientKey',
    );
    const apiHost =
      config.getOptionalString('app.analytics.posthog.apiHost') ??
      'https://eu.i.posthog.com';
    const autocapture =
      config.getOptionalBoolean('app.analytics.posthog.autocapture') ?? true;

    // Init only if key is present
    if (!clientKey) {
      // eslint-disable-next-line no-console
      console.warn('PostHog: apiKey missing in app-config; skipping init');
      return;
    }


    posthog.init(clientKey, {
      api_host: apiHost,
      autocapture,
      capture_pageview: true,
      capture_pageleave: true,
    });

    // Identify the user from profile (email preferred)
    const distinctId = profile?.email ?? profile?.displayName;
    if (distinctId) {
      posthog.identify(distinctId, {
        email: profile?.email,
        name: profile?.displayName,
      });
    }
  }, [config, profile?.email, profile?.displayName]);
}
